import { z } from 'zod/v3';
import { errorMap, zValidPeriod } from '../../../common/utils/schema';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './UserRoleValidFormDataSchema.translations.json';

const { addTranslations, t } = i18nNsFactory('User');
addTranslations(translations);

export const UserRoleValidFormDataSchema = z.object({
  id: z.number(errorMap(() => t('validation.roles.id.required'))),
  validPeriod: zValidPeriod(),
});
